<template>
  <div id="app">
    <header>
      <div class="container m_container m_container_pad" >
        <div class="row">
          <div class="col-lg-12">
            <nav class="navbar navbar-expand-lg">
              <a class="navbar-brand" href="/">
                <img :src="require('@/assets/ch/ls-chjt+logo.png')" alt="Logo" style="width: 50vw;"/>
              </a>
              <button class="navbar-toggler" @click="navbarToggler()">
                <span class="toggler-icon"> </span>
                <span class="toggler-icon"> </span>
                <span class="toggler-icon"> </span>
              </button>
              <el-drawer
               v-if="screenWidth<=991"
                size="60%"
                :visible.sync="drawer"
                :show-close="false"
                direction="rtl">
                <ul id="nav" class="navbar-nav mx-auto" @click="openMouseleave">
				          <navigation  @openMouseleave="openMouseleave" equipment="mobile" ref="navigations" :model="item" v-for="(item,index) in navigations" :key="item.strId"></navigation>
                </ul>
              </el-drawer>
              <div class="navbar-collapse" v-if="screenWidth>=992">
                <ul id="nav" class="navbar-nav mx-auto" @mouseleave="openMouseleave" >
				          <navigation  @openMouseleave="openMouseleave" equipment="pc"  ref="navigations" :model="item" v-for="(item,index) in navigations" :key="item.strId"></navigation>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
    <router-view :screenWidth="screenWidth"/>
    <footer class="ch-gw-footer gw_app_footer"  >
      <div class="shape s-1">
        <img :src= "require('@/assets/footer/s-1.png')"   />
      </div>
      <div class="ch-gw-footer-widgets">
        <div class="container" style="padding: 1rem;">
          <div class="gw_footer_flex" >
            <div class="gw_footer" >
                <div style="width: 40%;">
                  <a href="/" class="ch-gw-footer-logo">
                    <img :src= "require('@/assets/ch/bs-chjt+logo.png')"  alt="logo" />
                  </a>
                  <p style="border-bottom: 1px solid rgba(255,255,255, 0.2);padding-top: 0.5rem;"></p>
                </div>
                <p style="padding-top: 1rem;color: rgba(255,255,255, 0.6);text-align: start;" v-for="(item,index) in homeBottoms.homeBottomInfoList" v-if="item.phone != null">
                  {{ item.phone }}
                </p>  
                <p style="padding-top: 1rem;color: rgba(255,255,255, 0.6);text-align: start;" v-for="(item,index) in homeBottoms.homeBottomInfoList" v-if="item.address != null">
                  {{ item.address }}
                </p>
            </div>
			<div class="gw_footer" style="display: flex;flex-direction: row;justify-content: flex-end;align-items: center;">
        <div style="width:100%;padding-right: 2%;">
					<p style="padding-top: 1rem;color: rgba(255,255,255, 1);text-align: end;">
						关注我们
                	</p>
					<p style="padding-top: 1rem;color: rgba(255,255,255, 0.7);text-align: end;font-size: 0.9rem;">
						关注官方微信公众号
                	</p>
					<p style="color: rgba(255,255,255, 0.7);text-align: end;font-size: 0.9rem;">
						微信扫描二维码·了解更多信息
                	</p>
				</div>
				<div class="gw_footer_img">
					<img :src= "homeBottoms.src"/>
				</div>
            </div>
          </div>
        </div>
      </div>
      
    </footer>

  </div>
</template>

<script>
  import { getNavigation,queryHomeSubmitData } from "@/utils/gw";
  import navigation from '@/components/navigation'
  export default {
	name: "App",
    components:{
		navigation
    },
    data() {
      return {
        drawer: false,
        navigations:{},
        fatherData:[],
        childData:[],
        homeBottoms:{},
        screenWidth:''
      };
    },
    mounted() {
    console.log = () => {}
		this.getNavigation();
		this.queryHomeSubmitData();
    this.screenWidth = window.innerWidth

      window.onresize = () => { 

        return (() => {
        console.log(window.innerWidth)
        this.screenWidth = window.innerWidth

        })()

      }

    },
    watch: {

      screenWidth: {

        handler: function (val, oldVal) {

        },

        immediate: true

      },

    },
    methods: {
    navbarToggler(){
      this.drawer = true
    },
		queryHomeSubmitData(){
			queryHomeSubmitData().then((e)=>{
        e.data.homeBottoms[0].src = e.data.homeBottoms[0].src.replaceAll("/dev-api","")
				this.homeBottoms = e.data.homeBottoms[0]
			})
		},	
		openMouseleave(model,str){
      console.log(model,str)
			this.navigations.forEach((e)=>{
				if(typeof model !='undefined' && e.strId == model.strid){
					e.open = false
				}

				if(typeof str =='undefined'){
					e.open = false
				}

				if(e.children!=null && e.children.length!=0){
					this.fopen(e.children,str)
				}
			})
		},
		fopen(c,str){
			c.forEach((e)=>{
				if(typeof model !='undefined' && e.strId == model.strid){
					e.open = false
				}

				if(typeof str =='undefined'){
					e.open = false
				}

				if(e.children!=null && e.children.length!=0){
					this.fopen(e.children)
				}
			})
		},
		getNavigation(){
			const that = this
            this.fatherData = []
            this.childData = []
            getNavigation().then((e)=>{
                e.data.navigations.forEach(t=>{
                    if (!t.children && typeof(t.children)!="undefined" && t.children!=0){ 
                        t.children = []
                    }
                    if(t.type == 'father'){
						            t.open = false
                        that.fatherData.push(t)
                    }
                    if(t.type == 'child'){
						            t.open = false
                        that.childData.push(t)
                    }
                })
                
                this.childData.sort(this.createComprisonFunction("fatherOrder"));
                
                

                that.childData.forEach(e=>{
                    that.childData.forEach(v=>{
                        if(e.order == v.fatherOrder){
                            e.children.push(v)
                        }
                    })
                })

               

                that.childData.forEach(e=>{
                    that.fatherData.forEach(v=>{
                        if(e.fatherOrder == v.order){
                            v.children.push(e)
                        }
                    })
                })
                
                const j = []

                that.fatherData.forEach(k=>{
                    j.push(k)
                })
                that.navigations =j
            })
		},
		createComprisonFunction(propertyName){
            return function(object1,object2){
                var value1 = object1[propertyName];
                var value2 = object2[propertyName];
                if(value1 < value2){
                    return -1;
                }else if(value1 > value2){
                    return 1;
                }else{
                    return 0;
                }
            }
        },
    }
  }
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.dropdown-item:focus, .dropdown-item:hover{
	background-color:rgba(0, 0, 0, 0) ;
}
.dropdown-menu{
	background-color: rgba(0, 0, 0, 0);
	border: 0px;
	padding:0px;
	
}
.el-drawer__header{
  height: 0px;
  padding:0px;
  margin-bottom:0px;
}
.navbar-collapse{
  white-space: nowrap;
}

</style>



// WEBPACK FOOTER //
// src/App.vue